/* BITRO Chat Widget
 *
 * Floating-Button unten links. Öffnet Popup mit:
 *  - Messages (streaming-aware)
 *  - Input
 *  - Email-Capture-Form (kann jederzeit aufgeklappt werden)
 *
 * Auto-Hide wenn .bitro-configurator im Viewport ist — sonst überdeckt der
 * Button auf Konfigurator-Seiten die Preview-Controls. Scroll-Event mit simpler
 * Intersect-Check (kein IntersectionObserver, damit's überall läuft).
 */
(function () {
  "use strict";

  if (window.__bitroChatLoaded) return;
  window.__bitroChatLoaded = true;

  const PROXY_BASE = "/apps/bitro-configurator";
  const STORAGE_KEY = "bitro_chat_conv_id";

  const getStorefrontClientId = () => {
    if (window.__bitroStorefrontClientId) return window.__bitroStorefrontClientId;
    const storageKey = "bitro_storefront_client_id";
    let id = "";
    try {
      id = window.localStorage.getItem(storageKey) || "";
      if (!/^[a-zA-Z0-9_-]{12,100}$/.test(id)) {
        id = window.crypto?.randomUUID?.() ||
          `bitro_${Date.now().toString(36)}_${Math.random().toString(36).slice(2)}`;
        window.localStorage.setItem(storageKey, id);
      }
    } catch (_) {
      id = `bitro_${Date.now().toString(36)}_${Math.random().toString(36).slice(2)}`;
    }
    window.__bitroStorefrontClientId = id;
    return id;
  };
  const storefrontClientId = getStorefrontClientId();

  // --- Persisted conversation-id ---
  let conversationId = null;
  try {
    conversationId = window.localStorage.getItem(STORAGE_KEY);
  } catch (_) {}

  // --- Root element ---
  const root = document.createElement("div");
  root.className = "bitro-chat";
  root.setAttribute("data-bitro-chat-root", "");
  root.innerHTML = [
    '<button class="bitro-chat__launcher" type="button" aria-label="Chat öffnen" data-bitro-chat-launcher>',
      '<svg class="bitro-chat__launcher-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">',
        '<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>',
      '</svg>',
      '<span class="bitro-chat__launcher-label">Chat</span>',
    '</button>',
    '<div class="bitro-chat__panel" data-bitro-chat-panel hidden>',
      '<div class="bitro-chat__head">',
        '<div class="bitro-chat__head-title">BITRO Support</div>',
        '<div class="bitro-chat__head-actions">',
          '<button type="button" class="bitro-chat__reset" aria-label="Neues Gespräch" title="Neues Gespräch starten" data-bitro-chat-reset>',
            '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5"/></svg>',
          '</button>',
          '<button type="button" class="bitro-chat__close" aria-label="Schließen" data-bitro-chat-close>×</button>',
        '</div>',
      '</div>',
      '<div class="bitro-chat__messages" data-bitro-chat-messages></div>',
      '<form class="bitro-chat__email" data-bitro-chat-email-form hidden>',
        '<div class="bitro-chat__email-title">Sollen wir dich per Email erreichen?</div>',
        '<input type="email" required placeholder="deine@email.de" data-bitro-chat-email-input class="bitro-chat__email-input">',
        '<input type="text" placeholder="Name (optional)" data-bitro-chat-email-name class="bitro-chat__email-input">',
        '<textarea placeholder="Notiz (optional)" rows="2" data-bitro-chat-email-note class="bitro-chat__email-input"></textarea>',
        '<div class="bitro-chat__email-actions">',
          '<button type="button" class="bitro-chat__email-cancel" data-bitro-chat-email-cancel>Abbrechen</button>',
          '<button type="submit" class="bitro-chat__email-submit">Senden</button>',
        '</div>',
      '</form>',
      '<div class="bitro-chat__email-status" data-bitro-chat-email-status hidden></div>',
      '<form class="bitro-chat__input-form" data-bitro-chat-form>',
        '<div class="bitro-chat__actions">',
          '<button type="button" class="bitro-chat__email-toggle" data-bitro-chat-email-toggle title="Email hinterlassen">',
            '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">',
              '<rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-10 6L2 7"/>',
            '</svg>',
            '<span>Email hinterlassen</span>',
          '</button>',
        '</div>',
        '<div class="bitro-chat__previews" data-bitro-chat-previews hidden></div>',
        '<div class="bitro-chat__input-row">',
          '<button type="button" class="bitro-chat__image-btn" aria-label="Bild hinzufügen" data-bitro-chat-image-btn title="Bild anhängen">',
            '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="m21 15-5-5L5 21"/></svg>',
          '</button>',
          '<input type="file" accept="image/*" multiple hidden data-bitro-chat-image-input>',
          '<textarea rows="1" class="bitro-chat__input" placeholder="Frage eingeben…" data-bitro-chat-input></textarea>',
          '<button type="submit" class="bitro-chat__send" aria-label="Senden" data-bitro-chat-send>',
            '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m3 3 18 9-18 9 4-9-4-9z"/></svg>',
          '</button>',
        '</div>',
      '</form>',
    '</div>',
  ].join("");
  document.addEventListener("DOMContentLoaded", () => document.body.appendChild(root));
  if (document.readyState !== "loading") document.body.appendChild(root);

  // --- Refs ---
  const $ = (sel) => root.querySelector(sel);
  const launcher = $("[data-bitro-chat-launcher]");
  const panel = $("[data-bitro-chat-panel]");
  const closeBtn = $("[data-bitro-chat-close]");
  const messagesEl = $("[data-bitro-chat-messages]");
  const form = $("[data-bitro-chat-form]");
  const input = $("[data-bitro-chat-input]");
  const sendBtn = $("[data-bitro-chat-send]");
  const emailForm = $("[data-bitro-chat-email-form]");
  const emailToggle = $("[data-bitro-chat-email-toggle]");
  const emailCancel = $("[data-bitro-chat-email-cancel]");
  const emailInput = $("[data-bitro-chat-email-input]");
  const emailName = $("[data-bitro-chat-email-name]");
  const emailNote = $("[data-bitro-chat-email-note]");
  const emailStatus = $("[data-bitro-chat-email-status]");
  const imageBtn = $("[data-bitro-chat-image-btn]");
  const imageInput = $("[data-bitro-chat-image-input]");
  const previewsEl = $("[data-bitro-chat-previews]");

  let greetingShown = false;
  let sending = false;
  let historyRendered = false;

  // Abort-Controller für den aktuell laufenden Request — damit Reset den
  // stream hart abbricht, statt dass er weiter in den neuen Chat reinschreibt.
  let currentAbort = null;
  let currentTypingInterval = null;


  // Auto-Scroll via rAF damit Layout vor scrollTop-Set fertig ist.
  // Messages-Container braucht die aktualisierte scrollHeight, sonst scrollen
  // wir auf die alte Höhe und User sieht nur den Anfang der neuen Message.
  function scrollMessagesToBottom() {
    requestAnimationFrame(() => {
      messagesEl.scrollTop = messagesEl.scrollHeight;
    });
  }

  // Verlauf schon beim Script-Load im Hintergrund fetchen — nicht erst beim
  // Panel-Open. Sonst kann der User die Nachricht abschicken BEVOR die History
  // ankommt, und die späte Antwort würde seine neue Nachricht überschreiben.
  const historyPromise = (async () => {
    if (!conversationId) return [];
    try {
      const resp = await fetch(
        PROXY_BASE + "/chat-history?conversationId=" + encodeURIComponent(conversationId),
      );
      if (!resp.ok) return [];
      const data = await resp.json();
      return Array.isArray(data.messages) ? data.messages : [];
    } catch {
      return [];
    }
  })();

  // --- Open/Close ---
  const isMobile = () => window.matchMedia("(max-width: 600px)").matches;
  let savedBodyOverflow = null;
  const lockBodyScroll = () => {
    if (savedBodyOverflow === null) {
      savedBodyOverflow = document.body.style.overflow || "";
      document.body.style.overflow = "hidden";
    }
  };
  const unlockBodyScroll = () => {
    if (savedBodyOverflow !== null) {
      document.body.style.overflow = savedBodyOverflow;
      savedBodyOverflow = null;
    }
  };

  // VisualViewport-API: passt das Panel auf Mobile exakt an den sichtbaren
  // Bereich an, wenn die Tastatur aufgeht. Sonst (iOS Safari) wird das ganze
  // Panel mit nach oben geshiftet und Input/Messages sind nicht gleichzeitig
  // sichtbar. dvh allein reicht nicht — VisualViewport ist der robuste Weg.
  const applyVisualViewport = () => {
    if (!isMobile() || panel.hidden) return;
    const vv = window.visualViewport;
    if (!vv) return;
    panel.style.position = "fixed";
    panel.style.left = "0";
    panel.style.right = "0";
    panel.style.top = vv.offsetTop + "px";
    panel.style.height = vv.height + "px";
    panel.style.width = vv.width + "px";
    // Messages an's untere Ende scrollen damit letzte Nachricht + Input
    // nach Tastatur-Open immer sichtbar bleibt.
    requestAnimationFrame(() => {
      messagesEl.scrollTop = messagesEl.scrollHeight;
    });
  };
  const clearVisualViewport = () => {
    panel.style.position = "";
    panel.style.left = "";
    panel.style.right = "";
    panel.style.top = "";
    panel.style.height = "";
    panel.style.width = "";
  };
  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", applyVisualViewport);
    window.visualViewport.addEventListener("scroll", applyVisualViewport);
  }

  const openPanel = async () => {
    panel.hidden = false;
    root.classList.add("bitro-chat--open");
    root.classList.remove("bitro-chat--hidden");
    if (isMobile()) {
      lockBodyScroll();
      applyVisualViewport();
    }

    if (!historyRendered) {
      const msgs = await historyPromise;
      if (messagesEl.children.length === 0) {
        if (msgs.length > 0) {
          for (const m of msgs) {
            if (m.role === "tool") {
              appendToolTick(m.toolName || "tool");
              let parsed;
              try { parsed = JSON.parse(m.content || "{}"); } catch { parsed = null; }
              if (parsed) appendToolCards({ name: m.toolName, result: parsed });
            } else if (m.role === "assistant") {
              let txt = (m.content || "").replace(/\[[^\]]*\]/g, "");
              appendMessage("assistant", txt, m.images);
            } else {
              appendMessage("user", m.content, m.images);
            }
          }
          greetingShown = true;
        } else {
          appendMessage("assistant", window.__bitroChatGreeting || "Hi! Wie kann ich dir helfen?");
          greetingShown = true;
        }
      }
      historyRendered = true;
    } else if (!greetingShown && messagesEl.children.length === 0) {
      appendMessage("assistant", window.__bitroChatGreeting || "Hi! Wie kann ich dir helfen?");
      greetingShown = true;
    }
    // Auto-Focus nur auf Desktop — auf Mobile triggert das die Tastatur
    // sofort und nimmt den halben Bildschirm weg, bevor der User überhaupt
    // den Chatverlauf gesehen hat.
    if (!isMobile()) {
      setTimeout(() => input.focus(), 60);
    }
  };
  const closePanel = () => {
    panel.hidden = true;
    root.classList.remove("bitro-chat--open");
    unlockBodyScroll();
    clearVisualViewport();
    setTimeout(updateVisibility, 0);
  };
  launcher.addEventListener("click", () => (panel.hidden ? openPanel() : closePanel()));
  closeBtn.addEventListener("click", closePanel);

  const resetBtn = $("[data-bitro-chat-reset]");
  if (resetBtn) {
    resetBtn.addEventListener("click", () => {
      if (!confirm("Neues Gespräch starten? Der bisherige Verlauf wird hier ausgeblendet.")) return;
      // Laufenden Request ABORT — sonst streamt der alte Response weiter in
      // den neuen Chat rein und tippt dort die alte Antwort aus.
      if (currentAbort) {
        try { currentAbort.abort(); } catch (_) {}
        currentAbort = null;
      }
      if (currentTypingInterval) {
        clearInterval(currentTypingInterval);
        currentTypingInterval = null;
      }
      sending = false;
      sendBtn.disabled = false;
      conversationId = null;
      try { window.localStorage.removeItem(STORAGE_KEY); } catch (_) {}
      messagesEl.innerHTML = "";
      greetingShown = false;
      appendMessage("assistant", window.__bitroChatGreeting || "Hi! Wie kann ich dir helfen?");
      greetingShown = true;
      input.focus();
    });
  }

  // --- Auto-Hide wenn Konfigurator im Viewport ---
  const configuratorEl = () => document.querySelector(".bitro-configurator");
  const updateVisibility = () => {
    // Auto-Hide gilt nur für den Launcher-Button, NICHT für ein offenes Panel.
    // Solang das Panel offen ist, lassen wir's offen (User-Intent).
    if (!panel.hidden) {
      root.classList.remove("bitro-chat--hidden");
      return;
    }
    const cfg = configuratorEl();
    if (!cfg) {
      root.classList.remove("bitro-chat--hidden");
      return;
    }
    const r = cfg.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const visible = r.bottom > 80 && r.top < vh - 20;
    root.classList.toggle("bitro-chat--hidden", visible);
  };
  window.addEventListener("scroll", updateVisibility, { passive: true });
  window.addEventListener("resize", updateVisibility);
  setTimeout(updateVisibility, 250);
  setTimeout(updateVisibility, 1500);

  // --- Textarea auto-grow + Mobile-Keyboard-Handling ---
  input.addEventListener("input", () => {
    input.style.height = "auto";
    input.style.height = Math.min(120, input.scrollHeight) + "px";
  });
  // Wenn Input fokussiert wird (Tastatur geht auf), kurz warten bis VisualViewport
  // sich anpasst, dann Position + Scroll neu setzen.
  input.addEventListener("focus", () => {
    if (!isMobile()) return;
    setTimeout(applyVisualViewport, 100);
    setTimeout(applyVisualViewport, 300);
  });
  input.addEventListener("keydown", (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      form.requestSubmit();
    }
  });

  // --- Messages UI ---
  function appendMessage(role, text, images) {
    const el = document.createElement("div");
    el.className = "bitro-chat__msg bitro-chat__msg--" + role;
    const bubble = document.createElement("div");
    bubble.className = "bitro-chat__bubble";
    if (images && images.length > 0) {
      for (const src of images) {
        const img = document.createElement("img");
        img.src = src;
        img.alt = "Anhang";
        img.className = "bitro-chat__bubble-img";
        bubble.appendChild(img);
      }
    }
    if (text) {
      const p = document.createElement("div");
      renderTextWithLinks(text, p);
      bubble.appendChild(p);
    } else if (!images || images.length === 0) {
      bubble.textContent = "";
    }
    el.appendChild(bubble);
    messagesEl.appendChild(el);
    scrollMessagesToBottom();
    return bubble;
  }

  // Parser: **bold** → <strong>, [label](url) → <a>, bare-URL → <a> mit auto-Label.
  function renderTextWithLinks(text, container) {
    // ACHTUNG bei der Bare-URL-Regex: `)` MUSS ausgeschlossen werden, sonst
    // bei "(https://x.de/y)" landet die schließende Klammer mit in der URL.
    const combinedRe =
      /\*\*([^*]+?)\*\*|\[([^\]]+)\]\((https?:\/\/[^\s)]+|mailto:[^\s)]+|\/[^\s)]*)\)|(https?:\/\/[^\s<>"'()]+)/gi;
    let lastIdx = 0;
    let m;
    while ((m = combinedRe.exec(text)) !== null) {
      if (m.index > lastIdx) {
        container.appendChild(document.createTextNode(text.slice(lastIdx, m.index)));
      }
      const boldText = m[1];
      const mdLabel = m[2];
      const mdUrl = m[3];
      const bareUrlRaw = m[4];
      if (boldText !== undefined) {
        const strong = document.createElement("strong");
        strong.textContent = boldText;
        container.appendChild(strong);
      } else if (mdLabel && mdUrl) {
        container.appendChild(makeLink(stripTrailingPunctuation(mdUrl), mdLabel));
      } else if (bareUrlRaw) {
        const cleanedUrl = stripTrailingPunctuation(bareUrlRaw);
        // Eventuelle Punktuation, die die Regex zur URL zog, wieder als Text einfügen
        const tail = bareUrlRaw.slice(cleanedUrl.length);
        container.appendChild(makeLink(cleanedUrl, friendlyLinkLabel(cleanedUrl)));
        if (tail) container.appendChild(document.createTextNode(tail));
      }
      lastIdx = m.index + m[0].length;
    }
    if (lastIdx < text.length) {
      container.appendChild(document.createTextNode(text.slice(lastIdx)));
    }
  }

  // Trailing-Punktuation am URL-Ende abschneiden (Satzzeichen die typischerweise
  // nicht zur URL gehören). `,.!?:;` werden gestrippt.
  function stripTrailingPunctuation(url) {
    return url.replace(/[),.!?:;]+$/, "");
  }

  function makeLink(url, label) {
    const a = document.createElement("a");
    a.href = url;
    a.className = "bitro-chat__link";
    a.textContent = label;
    return a;
  }

  function friendlyLinkLabel(url) {
    try {
      const u = new URL(url);
      const host = u.hostname.replace(/^www\./, "");
      if (/youtube\.com|youtu\.be/.test(host)) return "YouTube-Video";
      if (/tiktok\.com/.test(host)) return "TikTok-Video";
      if (/instagram\.com/.test(host)) return "Instagram";
      if (/bitro\.de|myshopify\.com/.test(host)) return "bitro.de" + (u.pathname.length > 1 ? u.pathname : "");
      return host + (u.pathname.length > 1 ? u.pathname : "");
    } catch {
      return url;
    }
  }

  function appendToolTick(name) {
    const el = document.createElement("div");
    el.className = "bitro-chat__tool";
    const label = (
      {
        get_order_status: "Bestellstatus nachschauen…",
        search_shop: "Shop durchsuchen…",
        web_search: "Internet-Recherche…",
        video_search: "Tutorial-Videos suchen…",
      }[name] || "Werkzeug: " + name
    );
    el.textContent = label;
    messagesEl.appendChild(el);
    scrollMessagesToBottom();
    return el;
  }

  // Rendert Tool-Results als rich-Cards direkt in den Chat (Shop-Produkte,
  // Tutorial-Videos etc.) — der Kunde kann direkt draufklicken.
  function appendToolCards(ev) {
    if (!ev || !ev.result || !ev.result.ok || !ev.result.data) return;
    const data = ev.result.data;
    if (ev.name === "search_shop") {
      const items = [];
      for (const it of (data.items || []).slice(0, 5)) {
        items.push({
          title: it.title,
          url: it.url,
          subtitle: it.subtitle || "",
          kind: it.kind || "Treffer",
        });
      }
      if (items.length === 0) {
        for (const p of (data.products || []).slice(0, 5)) {
          items.push({
            title: p.title,
            url: p.url,
            subtitle: p.price || "",
            kind: "Produkt",
          });
        }
        for (const pg of (data.pages || []).slice(0, 5)) {
          if (items.length >= 5) break;
          items.push({ title: pg.title, url: pg.url, subtitle: "Info-Seite", kind: "Seite" });
        }
      }
      if (items.length > 0) renderCardList(items);
    } else if (ev.name === "video_search") {
      const items = (data.results || []).slice(0, 2).map((v) => ({
        title: v.title,
        url: v.url,
        subtitle: v.source === "youtube" ? "YouTube" : v.source === "tiktok" ? "TikTok" : "Video",
        kind: "Tutorial",
      }));
      if (items.length > 0) renderCardList(items);
    } else if (ev.name === "get_order_status") {
      if (data && data.found) {
        const items = [{
          title: `Bestellung ${data.order_number}`,
          url: "",
          subtitle: `${data.financial_status ?? ""} · ${data.fulfillment_status ?? ""}`,
          kind: "Status",
        }];
        for (const t of (data.tracking || [])) {
          if (t.url) {
            items.push({
              title: `${t.company ?? "Sendung"}: ${t.number ?? "Tracking"}`,
              url: t.url,
              subtitle: "Sendung verfolgen",
              kind: "Tracking",
            });
          }
        }
        renderCardList(items);
      }
    }
  }

  function renderCardList(items) {
    const wrap = document.createElement("div");
    wrap.className = "bitro-chat__cards";
    for (const it of items) {
      const card = it.url
        ? document.createElement("a")
        : document.createElement("div");
      if (it.url) {
        card.href = it.url;
      }
      card.className = "bitro-chat__card";
      const kind = document.createElement("span");
      kind.className = "bitro-chat__card-kind";
      kind.textContent = it.kind;
      card.appendChild(kind);
      const title = document.createElement("span");
      title.className = "bitro-chat__card-title";
      title.textContent = it.title;
      card.appendChild(title);
      if (it.subtitle) {
        const sub = document.createElement("span");
        sub.className = "bitro-chat__card-sub";
        sub.textContent = it.subtitle;
        card.appendChild(sub);
      }
      wrap.appendChild(card);
    }
    messagesEl.appendChild(wrap);
    scrollMessagesToBottom();
  }

  // --- Image selection + preview ---
  const MAX_IMAGES = 3;
  const MAX_DIM = 1024;
  let pendingImages = []; // Array<string> (data URLs)

  imageBtn.addEventListener("click", () => imageInput.click());
  imageInput.addEventListener("change", async () => {
    const files = Array.from(imageInput.files || []);
    imageInput.value = "";
    for (const f of files) {
      if (pendingImages.length >= MAX_IMAGES) break;
      if (!f.type.startsWith("image/")) continue;
      try {
        const dataUrl = await resizeImageToDataUrl(f, MAX_DIM);
        pendingImages.push(dataUrl);
      } catch (_) {}
    }
    renderPreviews();
  });

  function renderPreviews() {
    previewsEl.innerHTML = "";
    if (pendingImages.length === 0) { previewsEl.hidden = true; return; }
    previewsEl.hidden = false;
    pendingImages.forEach((src, idx) => {
      const chip = document.createElement("div");
      chip.className = "bitro-chat__preview";
      const img = document.createElement("img");
      img.src = src;
      chip.appendChild(img);
      const rm = document.createElement("button");
      rm.type = "button";
      rm.className = "bitro-chat__preview-remove";
      rm.setAttribute("aria-label", "Entfernen");
      rm.textContent = "×";
      rm.addEventListener("click", () => {
        pendingImages.splice(idx, 1);
        renderPreviews();
      });
      chip.appendChild(rm);
      previewsEl.appendChild(chip);
    });
  }

  async function resizeImageToDataUrl(file, maxDim) {
    const bitmap = await createImageBitmap(file).catch(() => null);
    if (!bitmap) return null;
    let { width, height } = bitmap;
    if (width > maxDim || height > maxDim) {
      const scale = Math.min(maxDim / width, maxDim / height);
      width = Math.round(width * scale);
      height = Math.round(height * scale);
    }
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(bitmap, 0, 0, width, height);
    return canvas.toDataURL("image/jpeg", 0.72);
  }

  // --- Send ---
  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    if (sending) return;
    const text = (input.value || "").trim();
    const imgs = pendingImages.slice();
    if (!text && imgs.length === 0) return;
    input.value = "";
    input.style.height = "auto";
    pendingImages = [];
    renderPreviews();
    sending = true;
    sendBtn.disabled = true;
    appendMessage("user", text, imgs);

    // Typing-Indicator: 3 animierte Dots ("schreibt gerade…"-Style).
    const typing = document.createElement("div");
    typing.className = "bitro-chat__typing";
    typing.innerHTML = '<span></span><span></span><span></span>';
    messagesEl.appendChild(typing);
    scrollMessagesToBottom();

    let botBubble = null;
    const abort = new AbortController();
    currentAbort = abort;

    try {
      const resp = await fetch(PROXY_BASE + "/chat", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          conversationId,
          clientId: storefrontClientId,
          message: text,
          images: imgs,
          pageUrl: location.href,
        }),
        signal: abort.signal,
      });
      if (!resp.ok || !resp.body) {
        throw new Error("HTTP " + resp.status);
      }
      const reader = resp.body.getReader();
      const dec = new TextDecoder();
      let buf = "";
      let gotFirstDelta = false;
      let bufferedText = "";
      let pendingText = "";
      let typingInterval = null;
      const CHARS_PER_TICK = 4;

      // Client-side Typewriter: App-Proxy buffert Server-Streams oft, damit's
      // trotzdem smooth aussieht puffern wir eingehende Chunks und geben sie
      // Character-by-Character aus.
      const ensureBubble = () => {
        if (!botBubble) {
          if (typing.parentNode) typing.parentNode.removeChild(typing);
          botBubble = appendMessage("assistant", "");
          botBubble.textContent = "";
        }
      };
      const isAtBottom = () => {
        const diff = messagesEl.scrollHeight - messagesEl.scrollTop - messagesEl.clientHeight;
        return diff < 60;
      };

      // Pick-Marker-Parser: erkennt `[pick:h1,h2,h3]` am Anfang der Antwort,
      // Brute-Force: ALLE `[...]` im Text werden entfernt — egal was drin
      // steht, egal wo. Wir wollen NIEMALS einen Bracket-Block in der
      // sichtbaren Antwort haben.
      const STRIP_BRACKET_RE = /\[[^\]]*\]/g;
      // Während des Streamens kann ein `[` schon da sein, aber der Inhalt +
      // schließendes `]` noch nicht. Diesen offenen Tail blenden wir aus,
      // damit User nicht den halben Inhalt sieht.
      const PARTIAL_BRACKET_RE = /\[[^\]]*$/;

      const stripPickMarker = (forceFlush) => {
        if (STRIP_BRACKET_RE.test(bufferedText)) {
          bufferedText = bufferedText.replace(STRIP_BRACKET_RE, "");
        }
        if (!forceFlush) {
          const partial = PARTIAL_BRACKET_RE.exec(bufferedText);
          if (partial) {
            return bufferedText.slice(0, partial.index);
          }
        }
        return bufferedText;
      };

      const startTyping = () => {
        if (typingInterval) return;
        typingInterval = setInterval(() => {
          if (abort.signal.aborted) {
            clearInterval(typingInterval);
            typingInterval = null;
            return;
          }
          if (!pendingText) return;
          const wasAtBottom = isAtBottom();
          const take = pendingText.slice(0, CHARS_PER_TICK);
          pendingText = pendingText.slice(CHARS_PER_TICK);
          bufferedText += take;
          ensureBubble();
          const display = stripPickMarker(false);
          botBubble.innerHTML = "";
          renderTextWithLinks(display, botBubble);
          if (wasAtBottom) scrollMessagesToBottom();
        }, 25);
        currentTypingInterval = typingInterval;
      };
      const stopTyping = () => {
        if (typingInterval) clearInterval(typingInterval);
        typingInterval = null;
        if (pendingText) {
          bufferedText += pendingText;
          pendingText = "";
        }
        if (botBubble) {
          const display = stripPickMarker(true);
          botBubble.innerHTML = "";
          renderTextWithLinks(display, botBubble);
        }
      };
      while (true) {
        const { value, done } = await reader.read();
        if (done) break;
        buf += dec.decode(value, { stream: true });
        let nl;
        while ((nl = buf.indexOf("\n")) >= 0) {
          const line = buf.slice(0, nl).trim();
          buf = buf.slice(nl + 1);
          if (!line) continue;
          let ev;
          try {
            ev = JSON.parse(line);
          } catch {
            continue;
          }
          if (ev.type === "conv") {
            conversationId = ev.id;
            try { window.localStorage.setItem(STORAGE_KEY, conversationId); } catch {}
          } else if (ev.type === "delta") {
            if (!gotFirstDelta) {
              gotFirstDelta = true;
              ensureBubble();
            }
            pendingText += ev.text;
            startTyping();
          } else if (ev.type === "tool") {
            appendToolTick(ev.name);
            appendToolCards(ev);
          } else if (ev.type === "error") {
            stopTyping();
            if (typing.parentNode) typing.parentNode.removeChild(typing);
            const errBubble = botBubble || appendMessage("assistant", "");
            // Technischen Fehler unterdrücken — freundlichen Kontakt-Hinweis zeigen
            errBubble.innerHTML = "";
            renderTextWithLinks(
              "Ups — aktuell gibt's ein Problem mit dem Chatbot. Schreib uns kurz direkt:\n\n• Email: [support@bitro.de](mailto:support@bitro.de)\n• WhatsApp: [+49 152 2172 4850](https://wa.me/4915221724850)\n\nWir melden uns schnell zurück.",
              errBubble,
            );
          } else if (ev.type === "done") {
            stopTyping();
          }
        }
      }
    } catch (err) {
      if (typingInterval) clearInterval(typingInterval);
      // Abort durch User-Reset ist kein Fehler — keine Error-Message zeigen
      if (abort.signal.aborted || (err && err.name === "AbortError")) {
        if (typing.parentNode) typing.parentNode.removeChild(typing);
      } else {
        if (typing.parentNode) typing.parentNode.removeChild(typing);
        const errBubble = botBubble || appendMessage("assistant", "");
        errBubble.innerHTML = "";
        renderTextWithLinks(
          "Ups — aktuell gibt's ein Problem mit dem Chatbot. Schreib uns kurz direkt:\n\n• Email: [support@bitro.de](mailto:support@bitro.de)\n• WhatsApp: [+49 152 2172 4850](https://wa.me/4915221724850)\n\nWir melden uns schnell zurück.",
          errBubble,
        );
      }
    } finally {
      // Controller + Typewriter-Referenz freigeben — Reset braucht sie nicht mehr
      if (currentAbort === abort) currentAbort = null;
      currentTypingInterval = null;
      sending = false;
      sendBtn.disabled = false;
      input.focus();
    }
  });

  // --- Email-Capture ---
  emailToggle.addEventListener("click", () => {
    emailForm.hidden = !emailForm.hidden;
    if (!emailForm.hidden) emailInput.focus();
  });
  emailCancel.addEventListener("click", () => (emailForm.hidden = true));
  emailForm.addEventListener("submit", async (e) => {
    e.preventDefault();
    const payload = {
      conversationId,
      clientId: storefrontClientId,
      email: emailInput.value.trim(),
      name: emailName.value.trim() || null,
      note: emailNote.value.trim() || null,
    };
    if (!payload.conversationId) {
      showEmailStatus("Bitte stell zuerst eine Frage, bevor du deine Email hinterlässt.", true);
      return;
    }
    try {
      const resp = await fetch(PROXY_BASE + "/chat-email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      if (!resp.ok) throw new Error("HTTP " + resp.status);
      showEmailStatus("Danke! Wir melden uns bei dir.", false);
      emailForm.hidden = true;
      emailInput.value = "";
      emailName.value = "";
      emailNote.value = "";
    } catch (err) {
      showEmailStatus("Konnte Email nicht speichern. Versuch's nochmal.", true);
    }
  });
  function showEmailStatus(msg, isError) {
    emailStatus.textContent = msg;
    emailStatus.hidden = false;
    emailStatus.classList.toggle("bitro-chat__email-status--err", !!isError);
    setTimeout(() => (emailStatus.hidden = true), 6000);
  }
})();
